import React from 'react';
import career from '../../img/career.svg';

function Jumbotron() {
    return (
        <div className='flex flex-col gap-y-7 items-center w-full justify-around  mb-20 md:mt-10 md:flex-row'>
            <div className='order-1 md:pl-10'>
                <h1 id='home' className='font-[800] mb-3 md:text-4xl text-2xl text-slate-800'>For You Job S<span className='text-sky-600'>ee</span>kers</h1>
                <p className='w-full text-sm md:w-3/4'>Searching for an employment? We provide various types of job offers from all over the world. Millions of people have trusted us to help them with their career. Feeling anxious about your CV? We got you covered. Get your CV reviewed by the experts for free.</p>
            </div>
            <img src={career} alt="svg" className='sm:w-1/3 w-2/3 pt-10 md:order-1' />
        </div>
    )
}

export default Jumbotron;